import { isDev } from '@/utils/common';
import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const Basis: AppRouteRecordRaw = {
  path: '/basis',
  name: 'Basis',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '基础设置',
    requiresAuth: true,
    icon: 'icon-settings',
    order: 7,
  },
  children: [
    // {
    //   path: 'sys-config',
    //   name: 'SysConfig',
    //   component: () => import('@/views/basis/sysConfig/app.vue'),
    //   meta: {
    //     title: '系统配置',
    //     requiresAuth: true,
    //     roles: ['*'],
    //   },
    // },
    {
      path: '/temporary-template',
      name: 'TemporaryTemplate',
      component: () => import('@/views/temporaryTemplate/index.vue'),
      meta: {
        title: '开发中',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    // {
    //   path: 'index',
    //   name: 'brandMang',
    //   component: () => import('@/views/basis/sysConfig/brandMang.vue'),
    //   meta: {
    //     title: '品牌管理',
    //     requiresAuth: true,
    //     roles: ['*'],
    //   },
    // },
    {
      path: 'technique',
      name: 'Technique',
      component: () => import('@/views/basis/sysConfig/technique.vue'),
      meta: {
        title: '工艺要求',
        requiresAuth: true,
        roles: ['techniqueGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'part',
      name: 'Part',
      component: () => import('@/views/basis/sysConfig/part.vue'),
      meta: {
        title: '尺寸指示',
        requiresAuth: true,
        roles: ['partGet'],
        hideInMenu: true,
      },
    },
    // {
    //   path: 'style',
    //   name: 'OldGoodsStyle',
    //   component: () => import('@/views/basis/sysConfig/style.vue'),
    //   meta: {
    //     title: '旧版-款式风格管理',
    //     requiresAuth: true,
    //     roles: ['*'],
    //   },
    // },
    {
      path: 'goods-style',
      name: 'GoodsStyle',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '款式风格管理',
        requiresAuth: true,
        roles: ['*'],
        amisAppId: isDev() ? '9b5003ce' : 'c613d0f4',
        hideInMenu: true,
      },
    },
    {
      path: 'color-manage',
      name: 'ColorManage',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '颜色管理',
        requiresAuth: true,
        roles: ['colorGet'],
        amisAppId: isDev() ? '2f4b5ce5' : 'd5a93050',
        hideInMenu: true,
      },
    },
    {
      path: 'size-manage',
      name: 'SizeManage',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '尺码管理',
        requiresAuth: true,
        roles: ['sizeGet'],
        amisAppId: isDev() ? '643f7297' : 'e045cc46',
        hideInMenu: true,
      },
    },
    {
      path: 'property',
      name: 'Property',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '物料规格',
        requiresAuth: true,
        roles: ['materialPropertyGet'],
        amisAppId: isDev() ? '54520b92' : 'e8bed282',
        hideInMenu: true,
      },
    },
    {
      path: 'material-type',
      name: 'MaterialType',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '物料类型',
        requiresAuth: true,
        roles: ['materialTypeGet'],
        amisAppId: isDev() ? 'ddcc644b' : 'e3711f89',
        hideInMenu: true,
      },
    },
    {
      path: 'material-category',
      name: 'MaterialCategory',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '物料分类',
        requiresAuth: true,
        roles: ['materialCategoryGet'],
        amisAppId: isDev() ? 'ea559ad5' : 'f9db3f13',
        hideInMenu: true,
      },
    },
    {
      path: 'goods-category',
      name: 'GoodsCategory',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '商品分类',
        requiresAuth: true,
        roles: ['categoryGet'],
        amisAppId: isDev() ? '3fa8c599' : '48333058',
        hideInMenu: true,
      },
    },
    {
      path: 'bland',
      name: 'Bland',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '品牌管理',
        requiresAuth: true,
        roles: ['brandGet'],
        amisAppId: isDev() ? 'de9561ef' : '0ca8147e',
        hideInMenu: true,
      },
    },
    {
      path: 'unit',
      name: 'Unit',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '单位管理',
        requiresAuth: true,
        roles: ['unitGet'],
        amisAppId: isDev() ? 'b7a43441' : '134e3412',
        hideInMenu: true,
      },
    },
    {
      path: 'season',
      name: 'Season',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '季节管理',
        requiresAuth: true,
        roles: ['seasonGet'],
        amisAppId: isDev() ? '4ffa32e6' : '5418dccd',
        hideInMenu: true,
      },
    },
    {
      path: 'ranges',
      name: 'Ranges',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '波段管理',
        requiresAuth: true,
        roles: ['rangesGet'],
        amisAppId: isDev() ? '98ba78c5' : '18ae44d3',
        hideInMenu: true,
      },
    },
    {
      path: 'order-type',
      name: 'OrderType',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '订单类型',
        requiresAuth: true,
        roles: ['orderTypeGet'],
        amisAppId: isDev() ? '4bbf9171' : '32a5b99e',
        hideInMenu: true,
      },
    },
    {
      path: 'work-process-group',
      name: 'WorkProcessGroup',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '节点分组管理',
        requiresAuth: true,
        roles: ['workProcessGroupGet'],
        amisAppId: isDev() ? '2b1ffe45' : 'd2154f36',
        hideInMenu: true,
      },
    },
    {
      path: 'clientItem',
      name: 'ClientItem',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '客户分类',
        requiresAuth: true,
        roles: ['clientItemGet'],
        amisAppId: isDev() ? 'ebf9aa79' : '1eb56deb',
        hideInMenu: true,
      },
    },
    {
      path: 'supplierLevel',
      name: 'SupplierLevel',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '供应商等级',
        requiresAuth: true,
        roles: ['supplierLevelGet'],
        amisAppId: isDev() ? 'be5df61e' : '28ddd2f6',
        hideInMenu: true,
      },
    },
    {
      path: 'balanceAccount',
      name: 'BalanceAccount',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '结算账户',
        requiresAuth: true,
        roles: ['accountGet'],
        amisAppId: isDev() ? '68139dd3' : 'b40d9248',
        hideInMenu: true,
      },
    },
    {
      path: 'accountType',
      name: 'AccountType',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '账目类型',
        requiresAuth: true,
        roles: ['accountItemGet'],
        amisAppId: isDev() ? 'e0480e21' : '3cb374d2',
        hideInMenu: true,
      },
    },
    {
      path: 'position',
      name: 'Position',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '职位',
        requiresAuth: true,
        roles: ['positionGet'],
        amisAppId: isDev() ? 'd7216dae' : '4159e7a7',
        hideInMenu: true,
      },
    },
    {
      path: 'supplier-manage',
      name: 'SupplierManage',
      component: () => import('@/views/basis/supplierManage/index.vue'),
      meta: {
        title: '供应商管理',
        requiresAuth: true,
        roles: ['supplierGet'],
      },
    },
    {
      path: 'supplier-add',
      name: 'SupplierAdd',
      component: async () => {
        const cpn = await import(
          '@/views/basis/supplierManage/addOrEditSupplier.vue'
        );
        return { ...cpn.default, name: 'SupplierAdd' };
      },
      meta: {
        title: '新增供应商',
        requiresAuth: true,
        roles: ['supplierEdit'],
        hideInMenu: true,
      },
    },
    {
      path: 'supplier-edit',
      name: 'SupplierEdit',
      component: async () => {
        const cpn = await import(
          '@/views/basis/supplierManage/addOrEditSupplier.vue'
        );
        return { ...cpn.default, name: 'SupplierEdit' };
      },
      meta: {
        title: '编辑供应商',
        requiresAuth: true,
        roles: ['supplierGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'client-management',
      name: 'ClientManagement',
      component: () => import('@/views/basis/sysConfig/clientManagement.vue'),
      meta: {
        title: '客户管理',
        requiresAuth: true,
        roles: ['clientGet'],
      },
    },
    {
      path: 'store-management',
      name: 'StoreManagement',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '仓库管理',
        requiresAuth: true,
        roles: ['storehouseGet'],
        amisAppId: isDev() ? '74ad579f' : '48091186',
      },
    },
    {
      path: 'print-setting',
      name: 'PrintSetting',
      component: () => import('@/views/basis/sysConfig/printSetting.vue'),
      meta: {
        title: '单据云打印',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'production-node-template',
      name: 'ProductionNodeTemplate',
      component: () => import('@/views/basis/productionNodeTemplate/index.vue'),
      meta: {
        title: '工序节点模板',
        requiresAuth: true,
        roles: ['workProcessTemplateGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'process-fee-template',
      name: 'ProcessFeeTemplate',
      component: () => import('@/views/basis/processFeeTemplate/index.vue'),
      meta: {
        title: '加工费模板',
        requiresAuth: true,
        roles: ['processFeeTemplateGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'production-order-template',
      name: 'ProductionOrderTemplate',
      component: () =>
        import('@/views/basis/productionOrderTemplate/index.vue'),
      meta: {
        title: '生产单模板',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'purchase-order-template',
      name: 'PurchaseOrderTemplate',
      component: () => import('@/views/basis/purchaseOrderTemplate/index.vue'),
      meta: {
        title: '采购单模板',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'sample-template',
      name: 'SampleTemplate',
      component: () => import('@/views/basis/sampleTemplate/index.vue'),
      meta: {
        title: '商品/设计款模板',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'design-order-template',
      name: 'DesignOrderTemplate',
      component: () => import('@/views/basis/designOrderTemplate.vue'),
      meta: {
        title: '版单模板',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'staff-management',
      name: 'StaffManagement',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '员工管理',
        requiresAuth: true,
        roles: ['userGet'],
        amisAppId: isDev() ? '99f254bb' : 'a4bcca99',
        hideInMenu: true,
      },
    },
    // {
    //   path: 'role-management-amis',
    //   name: 'RoleManagementAmis',
    //   component: () => import('@/components/QsAmis/index.vue'),
    //   meta: {
    //     title: '角色权限amis',
    //     requiresAuth: true,
    //     roles: ['*'],
    //     hideInMenu: !isDev(),
    //     amisAppId: isDev() ? '732a6161' : 'c643bd36',
    //   },
    // },
    {
      path: 'role-management',
      name: 'RoleManagement',
      component: () => import('@/views/basis/role/index.vue'),
      meta: {
        title: '角色权限',
        requiresAuth: true,
        roles: ['roleGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'department',
      name: 'Department',
      component: () => import('@/components/QsAmis/index.vue'),
      meta: {
        title: '组织架构',
        requiresAuth: true,
        roles: ['departmentGet'],
        amisAppId: isDev() ? '2a6163a3' : '54cdc377',
        hideInMenu: true,
      },
    },
    {
      path: 'log-query',
      name: 'LogQuery',
      component: () => import('@/views/basis/logQuery/index.vue'),
      meta: {
        title: '日志查询',
        requiresAuth: true,
        roles: ['operateLog'],
        hideInMenu: true,
      },
    },
    {
      path: 'clothing-node-template',
      name: 'ClothingNodeTemplate',
      component: () => import('@/views/basis/clothingNodeTemplate/index.vue'),
      meta: {
        title: '样衣节点模板',
        requiresAuth: true,
        roles: ['designNodeGet'],
        hideInMenu: true,
      },
    },
    {
      path: 'index',
      name: 'sysConfigIndex',
      component: () => import('@/views/basis/sysConfig/index.vue'),
      meta: {
        title: '系统配置',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'sys-control',
      name: 'SystemControl',
      component: () => import('@/views/basis/sysConfig/control.vue'),
      meta: {
        title: '系统控制',
        requiresAuth: true,
        ignoreCache: true,
        roles: ['systemConfigGet'],
      },
    },
  ],
};

export default Basis;
